import React, { useEffect, useState } from "react";
import DynamicTable from "../../Components/Table/DynamicTable"; // Adjust path as needed
import { useDispatch, useSelector } from "react-redux";
import {
  CustomerOn,
  CustomerOnP,
  fetchCustomerData,
} from "../../Redux/Slice/AddCustomer";
import { IoMdClose } from "react-icons/io";
import Loader from "../../Components/Loader/Loader";

const ShowAllCustomers = () => {
  const dispatch = useDispatch();

  const { CustomerData } = useSelector((state) => state.AddCustomer);

  useEffect(() => {
    dispatch(fetchCustomerData());
  }, [dispatch]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProfile(null);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "CompanyName", headerName: "Company Name", flex: 1 },
    { field: "MobileNumber", headerName: "Mobile Number", flex: 1 },
    {
      field: "profile",
      headerName: "Profile Mode",
      flex: 1,
      renderCell: (params) => (
        <button
          onClick={(e) => handleOnClick(e, params.row.MainId)}
          className={`btn text-sm uppercase min-w-16 px-4 py-2 rounded shadow-lg`}
          style={{
            backgroundColor: params.row.Profile === "On" ? "blue" : "red",
            color: "white", // Ensure the text color is readable
          }}
        >
          {params.row.Profile}
        </button>
      ),
    },

    {
      field: "Priority",
      headerName: "Priority Mode",
      flex: 1,
      renderCell: (params) => (
        <button
          onClick={(e) => handleOnClickP(e, params.row.MainId)}
          className={`btn text-sm uppercase min-w-16 px-4 py-2 rounded shadow-lg`}
          style={{
            backgroundColor: params.row.Priority === "On" ? "blue" : "red",
            color: "white", // Ensure the text color is readable
          }}
        >
          {params.row.Priority}
        </button>
      ),
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 1.5,
      renderCell: (params) => (
        <button
          onClick={() => handleViewProfile(params.row)}
          // className="rounded-md bg-[#122A47] text-white font-medium py-2 px-3 text-sm"
          className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600"
        >
          View Profile
        </button>
      ),
    },
  ];

  const rows =
    CustomerData?.data?.map((el, index) => ({
      // Use CustomerData to map rows
      id: el.id || index + 1,
      CompanyName: el.WhaClientName,
      MobileNumber: el.ContactNo,
      Profile: el.profile,
      MainId: el._id,
      Email: el.Email,
      Priority: el.Priority,
    })) || [];

  const handleViewProfile = (rowData) => {
    setSelectedProfile(rowData);
    setIsModalOpen(true);
  };

  const handleOnClick = (event, rowData) => {
    event.preventDefault();
    dispatch(CustomerOn(rowData));
  };

  const handleOnClickP = (event, rowData) => {
    event.preventDefault();
    dispatch(CustomerOnP(rowData));
  };

  if (!CustomerData?.data) {
    return <Loader />;
  }

  return (
    <div className="p-2 sm:p-3 lg:p-6">
      <div className="subTitle my-5">
        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
          Show All Customer
        </h3>
      </div>

      <div className="my-3">
        <DynamicTable columns={columns} rows={rows} />
      </div>

      {/* Modal */}
      {isModalOpen && selectedProfile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-[90%] max-w-md p-6 rounded-lg shadow-lg text-gray-800 relative">
            <h2 className="text-xl font-semibold mb-4">Profile Details</h2>
            <div className="space-y-2">
              <p>
                <strong>Name:</strong> {selectedProfile.CompanyName}
              </p>
              <p>
                <strong>Email:</strong> {selectedProfile.Email}
              </p>
              <p>
                <strong>Mobile Number:</strong> {selectedProfile.MobileNumber}
              </p>
            </div>
            <button
              onClick={closeModal}
              className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded"
            >
              Close
            </button>
            {/* Close button top-right (optional) */}
            <button
              onClick={closeModal}
              className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
            >
              <IoMdClose />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowAllCustomers;
